// src/components/Home/Industries.jsx
import React from "react";
import {
  FaIndustry,
  FaShoppingCart,
  FaLeaf,
  FaHardHat,
  FaMountain,
  FaClinicMedical,
} from "react-icons/fa";
import "./Industries.css";

const Industries = () => {
  const industries = [
    {
      icon: <FaIndustry className="industry-icon" />,
      title: "Manufacturing",
      description:
        "Inbound raw materials & machinery timed with production schedules. Just-in-time delivery and supply chain optimization.",
      color: "#1a73e8",
    },
    {
      icon: <FaShoppingCart className="industry-icon" />,
      title: "Retail & E-Commerce",
      description:
        "Pick & pack, inventory flow, and nationwide last-mile. Efficient fulfillment for retail chains and online stores.",
      color: "#fbbc04",
    },
    {
      icon: <FaLeaf className="industry-icon" />,
      title: "Agriculture & Perishables",
      description:
        "Priority clearance and temperature-aware handling. Specialized logistics for fresh produce and agricultural products.",
      color: "#34a853",
    },
    {
      icon: <FaHardHat className="industry-icon" />,
      title: "Construction & Heavy Equipment",
      description:
        "Project cargo planning for oversize materials. Specialized handling for construction materials and equipment.",
      color: "#ff6b35",
    },
    {
      icon: <FaMountain className="industry-icon" />,
      title: "Mining",
      description:
        "Heavy equipment and spares with permits and compliance. Reliable logistics for mining operations and equipment.",
      color: "#8b5cf6",
    },
    {
      icon: <FaClinicMedical className="industry-icon" />,
      title: "Pharmaceutical & Healthcare",
      description:
        "Permit-driven imports with disciplined lead times. Compliant and secure logistics for healthcare products.",
      color: "#ea4335",
    },
  ];

  return (
    <section className="industries-section section section-white">
      <div className="container">
        <div className="section-header text-center">
          <h2>Industries We Serve</h2>
          <p className="section-subtitle">
            Trusted by leading businesses across East Africa for reliable,
            compliant, and efficient logistics solutions
          </p>
        </div>

        {/* First Row – 3 Industries */}
        <div className="industries-row">
          {industries.slice(0, 3).map((industry, index) => (
            <div key={index} className="industry-card">
              <div className="icon-wrapper" style={{ color: industry.color }}>
                {industry.icon}
              </div>
              <h3>{industry.title}</h3>
              <p>{industry.description}</p>
            </div>
          ))}
        </div>

        {/* Second Row – Next 3 Industries */}
        <div className="industries-row">
          {industries.slice(3, 6).map((industry, index) => (
            <div key={index + 3} className="industry-card">
              <div className="icon-wrapper" style={{ color: industry.color }}>
                {industry.icon}
              </div>
              <h3>{industry.title}</h3>
              <p>{industry.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;
